import getSingleComputedString from "./get-multi-string";

/**
 *
 * @param {PropertyValueProps} item
 * @param {Array<String | Array<String>>} array
 * @param {Number} progress
 * @param {String} initial
 * @param {String} current
 * @param {Number | null} index
 */
const getCurrentAndPrevious = (
  item,
  array,
  progress,
  initial,
  current,
  index
) => {
  // TODO: optimize
  const last =
    item.get("parent-item")?.get("last-initial") || item.get("last-initial");

  if (array.length) {
    let values = [];

    if (index !== null) {
      for (let i = 0; i < array.length; i++) {
        if (array[i]?.[index] !== undefined) {
          values.push([array[i][index]]);
        }
      }
    }

    const store = values.length ? values : array;
    const joined = store.join(" - ");
    const previous = ` - (${joined})`;

    if (last) {
      if (previous) {
        return getSingleComputedString(item, last, progress, current, index);
      }
    }

    const computed = `(${progress} * (${initial}${previous} - ${current}))`;
    item.set("last-computed", computed);

    return computed;
  }

  if (last) {
    return getSingleComputedString(item, last, progress, current, index);
  }

  const computed = `(${progress} * (${initial} - ${current}))`;
  item.set("last-computed", computed);

  return computed;
};

export default getCurrentAndPrevious;

/*
Only one
transform: scaleX(calc(1 - var(--comp2-1)));
--comp2-1: (1 * (1 - 1.5)) - (0 * (1.5 - 0.5)) - (0 * (0.5 - 2)) - (0 * (2 - 1));

Two
transform: scaleX(calc(1 - var(--comp1-1) - var(--comp2-1)));
--comp1-1: 1 * (1 - 0.2);
--comp2-1: (1 * (1 - (var(--comp1-1)) - 1.5)) - (0 * (1.5 - 0.5)) - (0 * (0.5 - 2)) - (0 * (2 - 1));
*/
